import { computed } from 'vue';

import { EducationLevelFilterOptionValue } from '@studyportals/search-filters';
import store from '@/study-search/store';

export default class FilterContainer {
	public bachelorsValue: string;
	public distanceLearningValue: string;
	public mastersValue: string;
	public phdValue: string;
	public shortCoursesValue: string;

	public portalType = computed((): string => {
		return store.getters.getPortalType();
	});

	constructor() {
		this.bachelorsValue = EducationLevelFilterOptionValue.BACHELOR;
		this.distanceLearningValue = EducationLevelFilterOptionValue.DISTANCE_LEARNING;
		this.mastersValue = EducationLevelFilterOptionValue.MASTER;
		this.phdValue = EducationLevelFilterOptionValue.PHD;
		this.shortCoursesValue = EducationLevelFilterOptionValue.SHORT_COURSE;
	}
}
